import t from 'react-translate';
import { Button } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { useMentorRequestContext } from '../mentor-request-context';
import { config } from '@config/pendo.config.json';

const MentorRequestSubmitButton = () => {
  const { formState } = useFormContext();
  const { sendingRequest } = useMentorRequestContext();
  const disabled =
    !formState.isValid || formState.isSubmitting || sendingRequest;
  const translationKey = sendingRequest ? 'SENDING_REQUEST' : 'SEND_REQUEST';
  const dataQATag =
    config.pendo.athena.mentorshipProgram.participantHome.mentorRequest.modal
      .mentee.sendRequestButton;

  return (
    <Button
      type='submit'
      size='lg'
      className='mt-2'
      disabled={disabled}
      data-qa={dataQATag}
    >
      {t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTEE_VIEW[
        translationKey
      ]()}
    </Button>
  );
};

export default MentorRequestSubmitButton;
